module.exports = __webpack_public_path__ + "ab37cddc48799af2b77241a27c2c9a06.png";